// Standaardtitels van de velden die een nieuw registratieformulier meekrijgt.
//
// Nodig omdat `Events.jsx` ('Formulier aanmaken voor activiteit') en
// `ActivityManager.jsx` (nieuwe activiteit) elk hun eigen kopie schreven. De
// titel van het outputveld was 'Noteer het aantal outputs'; wie het formulier
// invult weet niet wat een output is (testronde 2026-10-28, Fatima B2).
// Bestaande formulieren houden hun titel; die is per veld aan te passen in de bouwer.

export const DATE_FIELD_TITLE = 'Noteer de datum'
export const OUTPUTS_FIELD_TITLE = 'Noteer de aantallen'

const defaultEventFieldTitles = { DATE_FIELD_TITLE, OUTPUTS_FIELD_TITLE }

export default defaultEventFieldTitles
